import { render } from "./module-muro.vue?vue&type=template&id=da7a8558"
import script from "./module-muro.vue?vue&type=script&lang=js"
export * from "./module-muro.vue?vue&type=script&lang=js"

import "./module-muro.vue?vue&type=style&index=0&id=da7a8558&lang=scss"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__